import { AppDispatch } from '@bonanza-social/toolkit/state';
import { TextProps } from '@bonanza-social/moonlight';
import { useNavigation, StackNavigationProp } from '@bonanza-social/navigation';
import { useTransmitResolver } from '@bonanza-social/transmit-resolver';

export type StatusConfig = {
  textProps: Pick<TextProps, 'locKey' | 'locNS'>;
  action: (dispatch: AppDispatch) => void;
};

export const useStatusConfig = () => {
  const { shouldTransmit, handleTransmit } = useTransmitResolver();

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const STATUS_CONFIG: Record<string, StatusConfig> = {
    DEFAULT: {
      textProps: {
        locNS: 'common',
        locKey: `${shouldTransmit ? 'claimReward' : 'play'}`,
      },
      action: () => {
        if (shouldTransmit) {
          handleTransmit();
          return;
        } else {
          navigation.navigate('PlayWithCoinsScreen');
        }
      },
    },
  };

  return STATUS_CONFIG;
};
